<template>
  <div class="show-data">
    <centerPart />
    <bottomPart />
  </div>
</template>

<script>
import centerPart from './components/center-part'
import bottomPart from './components/bottom-part'
export default {
  components: {
    centerPart,
    bottomPart
  }
}
</script>

<style scoped>
.show-data {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}
</style>